import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ConfigApi } from "../../config-api";
import { ApiCallingService } from "../../services/api-calling.service";

@Component({
  selector: "app-vending-settlements-details",
  templateUrl: "./vending-settlements-details.component.html",
  styleUrls: ["./vending-settlements-details.component.css"],
})
export class DonationSettlementsDetailComponent implements OnInit {
  donationId: string;
  details: any;
  transactionIds: any;
  constructor(
    private apiCallingService: ApiCallingService,
    private route: ActivatedRoute
  ) {
    this.donationId = this.route.snapshot.paramMap.get("id") || "";
  }

  ngOnInit(): void {
    this.getDonationDetails();
  }

  getDonationDetails() {
    this.apiCallingService
      .callAPI(
        {},
        "GET",
        ConfigApi.URLS.VENDING_DONATION_SETTLEMENT.DETAILS +
          "/" +
          this.donationId
      )
      .subscribe((res) => {
        if (this.apiCallingService.handleSuccess(res)) {
          this.details = res.data;
          this.transactionIds = res.data?.[0]?.transactionIds;
        }
      });
  }
}
